import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
//Language
import { useIntl } from "react-intl";

//Actions
import {
    showJSONCompareModalHide
} from 'Redux/actions';

import ReactJsonViewCompare from 'react-json-view-compare';

const ShowJSONCompare = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //redux states
    const openModal = useSelector(state => state.showJSONCompareRedux.openModal);

    const closeModal = () => {
        dispatch(showJSONCompareModalHide());
    }

    return (
        <Modal
            open={openModal}
            title={props.title ? props.title : ""}
            handleClose={() => {
                closeModal();
            }}
            position="right"
            size="medium"
            headerStyle={{ zIndex: "9" }}
        >
            <ModalBody>
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <ReactJsonViewCompare oldData={props.oldData} newData={props.newData} />
                </div>
            </ModalBody>
            <ModalFooter style={{ zIndex: "9" }}>
                <Button className="btn btn-dark-blue"
                    onClick={() => {
                        closeModal()
                    }}
                >
                    {messages["common_cancel"]}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default ShowJSONCompare;